<div class="page-container">
    <div class="page-header">
        <button class="btn-back" routerLink="/home/consignee-registration">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Consignees</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit Consignee' : 'New Consignee Registration' }}</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update consignee information and locations' : 'Add a new consignee to your delivery network' }}</p>
        </div>
    </div>

    <div class="form-card" [class.loading]="isLoading">
        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">Processing...</p>
        </div>
        <!-- Consignee Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>person</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Consignee Information</h2>
                    <p>Basic details about the consignee</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Consignee Name</label>
                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [(ngModel)]="nameValue" placeholder="Enter consignee name" />
                </mat-form-field>
            </div>
        </div>

        <!-- Location Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>location_on</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Location Information</h2>
                    <p>Add delivery locations and contact details</p>
                </div>
            </div>

            <!-- Existing Locations Table -->
            <div *ngIf="branches.length > 0" class="branches-table-container">
                <div class="table-header-label">
                    <mat-icon>list</mat-icon>
                    <span>Existing Locations ({{ branches.length }})</span>
                </div>
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Contact Name</th>
                            <th>Contact Number</th>
                            <th>Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of branches; let i = index" class="table-row"
                            [class.selected-row]="selectedBranchIndex === i"
                            (click)="onBranchRowClick(data, i)">
                            <td>{{ data.contacts && data.contacts[0] ? data.contacts[0].contactName : '—' }}</td>
                            <td>{{ data.contacts && data.contacts[0] ? (data.contacts[0].phoneNumber | phoneFormat) : '—' }}</td>
                            <td>{{ data.address || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Add/Edit Location Form -->
            <div class="branch-form-container">
                <div class="branch-form-header">
                    <mat-icon>add_location</mat-icon>
                    <span>{{ selectedBranchIndex >= 0 ? 'Edit Location' : 'Add New Location' }}</span>
                </div>

                <div class="form-group">
                    <label class="form-label">Address</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">location_on</mat-icon>
                        <input matInput [(ngModel)]="address" placeholder="Enter delivery address" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Contact Information</label>
                    <div class="contacts-list">
                        <div *ngFor="let contact of contacts; let i = index" class="contact-row">
                            <div class="contact-badge" *ngIf="i === 0">Primary</div>
                            <div class="contact-fields">
                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">person</mat-icon>
                                    <input matInput [(ngModel)]="contact.name" placeholder="Contact name" />
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">phone</mat-icon>
                                    <input matInput [(ngModel)]="contact.phone" placeholder="Phone number" appPhoneFormat />
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">work</mat-icon>
                                    <input matInput [(ngModel)]="contact.position" placeholder="Position" />
                                </mat-form-field>
                            </div>
                            <button *ngIf="contacts.length > 1" type="button" class="contact-btn contact-btn-remove"
                                (click)="removeContact(i)">
                                <mat-icon>remove</mat-icon>
                            </button>
                        </div>
                        <button type="button" class="contact-btn-add-new" (click)="addContact()">
                            <mat-icon>add</mat-icon>
                            <span>Add Contact</span>
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Location on Map</label>
                    <div class="map-container">
                        <app-google-map [height]="'250px'" [location]="currentLocation" (mapClick)="handleMapClick($event)"
                            (locationChanged)="handleLocationChanged($event)"></app-google-map>
                    </div>
                </div>

                <div class="branch-actions">
                    <button type="button" class="btn-secondary" (click)="addBranchBtnAction()">
                        <mat-icon>add_location_alt</mat-icon>
                        <span>Add Location</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Additional Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>notes</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Additional Information</h2>
                    <p>Any extra notes or remarks</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Remark</label>
                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [(ngModel)]="remark" placeholder="Enter any remarks or notes" />
                </mat-form-field>
            </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
            <button type="button" class="btn-cancel" routerLink="/home/consignee-registration">
                Cancel
            </button>
            <button type="submit" class="btn-primary" (click)="submitButtonAction()">
                <mat-icon>{{ isEdit === 'true' ? 'save' : 'person_add' }}</mat-icon>
                <span>{{ isEdit === 'true' ? 'Update Consignee' : 'Register Consignee' }}</span>
            </button>
        </div>
    </div>
</div>
